// src/Components/TargetUrlInput.js
import React from 'react';
import { Stack, TextField } from '@mui/material';

const TargetUrlInput = ({ baseUrl, setBaseUrl, finalUrl, showBaseUrlError = false, disabled = false }) => {
  return (
    <Stack spacing={1} sx={{ mb: 1 }}>
      <TextField
        label="Destination URL"
        fullWidth
        value={baseUrl}
        onChange={(e) => setBaseUrl(e.target.value)}
        disabled={disabled}
        inputProps={{ style: { fontFamily: 'monospace', fontSize: '0.9rem' } }}
        margin="dense"
        error={showBaseUrlError}
        helperText={showBaseUrlError ? 'Enter a valid URL including https://' : 'Where the short link should send someone after tracking is applied.'}
        required
      />
      <TextField
        label="Tracked Destination Preview"
        fullWidth
        value={finalUrl || ''}
        InputProps={{
          readOnly: true,
          disabled,
          style: { fontFamily: 'monospace', fontSize: '0.9rem' },
        }}
        helperText="This is the tracked destination that will be saved when you click Generate QR."
        margin="dense"
      />
    </Stack>
  );
};

export default TargetUrlInput;
